export default __webpack_public_path__ + "static/media/use-a-template.8fadb310.svg";